import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import LoggedApp from "./LoggingWrapApp";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <LoggedApp />
  </React.StrictMode>
);
